module.exports = __webpack_public_path__ + "img/pink.be5030ca.webp";